import { LngLat } from 'maplibre-gl';
import config from '../../../config';
import axios from 'axios';
function checkAndnormalizeOpt(opt) {
    if (!opt.geometry) {
        if (!opt.origin) {
            throw new Error('origin is required in NavigationRequest if geometry is not provided');
        }
        if (!opt.destination) {
            throw new Error('destination is required in NavigationRequest if geometry is not provided');
        }
    }
    const nOpt = Object.assign({}, opt, {
        origin: opt.origin ? LngLat.convert(opt.origin) : opt.origin,
        destination: opt.destination ? LngLat.convert(opt.destination) : opt.destination,
        waypoints: opt.waypoints ? opt.waypoints.map((w) => LngLat.convert(w)) : opt.waypoints,
    });
    if (nOpt.approaches) {
        if (nOpt.waypoints) {
            if (nOpt.waypoints.length + 1 !== nOpt.approaches.length) {
                throw new Error('The number of approaches must be one more than the number of waypoints.');
            }
        }
        else {
            if (nOpt.approaches.length !== 1) {
                throw new Error('The number of approaches must be one more than the number of waypoints. ');
            }
        }
    }
    return nOpt;
}
/**
 * A service for calculating navigation between locations.
 * Can be accessed by `nextbillion.maps.NavigationService` if you load SDK by CDN url.
 */
export class NavigationService {
    /**
     * Request navigation between an origin and a destination.
     * @param opt request options
     * @returns navigation result of the request
     */
    async route(opt) {
        if (!config.API_KEY) {
            throw new Error('In order to call the NextBillion.ai API, you must provide a valid API Key.');
        }
        if (!config.API_HOST) {
            throw new Error('An API host is required to make request to NextBillion.ai API.');
        }
        const nOpt = checkAndnormalizeOpt(opt);
        const params = {
            key: config.API_KEY,
        };
        if (nOpt.geometry) {
            params.geometry = nOpt.geometry;
        }
        if (nOpt.origin) {
            params.origin = `${nOpt.origin.lat},${nOpt.origin.lng}`;
        }
        if (nOpt.destination) {
            params.destination = `${nOpt.destination.lat},${nOpt.destination.lng}`;
        }
        if (Array.isArray(nOpt.waypoints)) {
            const waypoints = nOpt.waypoints.map((point) => `${point.lat},${point.lng}`).join('|');
            params['waypoints'] = waypoints;
        }
        if (nOpt.geometryType) {
            params.geometry_type = nOpt.geometryType;
        }
        if (nOpt.mode) {
            params.mode = nOpt.mode;
        }
        if (nOpt.lang) {
            params.lang = nOpt.lang;
        }
        if (nOpt.alternatives) {
            params.alternatives = nOpt.alternatives;
        }
        if (nOpt.altCount) {
            params.altcount = nOpt.altCount;
        }
        if (nOpt.geometry) {
            params.geometry = nOpt.geometry;
        }
        if (nOpt.avoid) {
            params.avoid = nOpt.avoid.join('|');
        }
        if (nOpt.overview) {
            params.overview = nOpt.overview;
        }
        if (nOpt.bearings) {
            params.bearings = nOpt.bearings;
        }
        if (nOpt.departureTime) {
            params.departure_time = nOpt.departureTime;
        }
        if (nOpt.approaches) {
            params.approaches = nOpt.approaches.join(';');
        }
        return await axios
            .get(`https://${config.API_HOST}/navigation/json?key=${config.API_KEY}`, {
            params,
        })
            .then((resp) => resp.data)
            .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            else {
                return err;
            }
        });
    }
}
//# sourceMappingURL=navigation.js.map